"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialExpandedReplies = exports.expandAllNestedReplies = exports.expandAllChildren = exports.collapseAllNestedReplies = exports.collapseAllChildren = exports.MAX_DEPTH = void 0;
var MAX_DEPTH = 3;
/**
 * Recursively removes all reply IDs from expandedReplies for the given replies object.
 */

exports.MAX_DEPTH = MAX_DEPTH;

var collapseAllChildren = function collapseAllChildren(replies, expandedReplies) {
  var result = replies.result;
  result.forEach(function (_ref) {
    var _children$metadata;

    var id = _ref.id,
        children = _ref.children;
    expandedReplies.delete(id);

    if ((children === null || children === void 0 ? void 0 : (_children$metadata = children.metadata) === null || _children$metadata === void 0 ? void 0 : _children$metadata.totalCount) > 0) {
      collapseAllChildren(children, expandedReplies);
    }
  });
};
/**
 * Recursively adds all reply IDs to expandedReplies for the given replies object, up to maxDepth.
 */


exports.collapseAllChildren = collapseAllChildren;

var expandAllChildren = function expandAllChildren(replies, expandedReplies, maxDepth) {
  var result = replies.result,
      metadata = replies.metadata;
  var currentDepthLevel = metadata.depthLevel;
  if (currentDepthLevel > maxDepth) return;
  result.forEach(function (_ref2) {
    var _children$metadata2;

    var id = _ref2.id,
        children = _ref2.children;
    expandedReplies.add(id);

    if ((children === null || children === void 0 ? void 0 : (_children$metadata2 = children.metadata) === null || _children$metadata2 === void 0 ? void 0 : _children$metadata2.totalCount) > 0) {
      expandAllChildren(children, expandedReplies, maxDepth);
    }
  });
};

exports.expandAllChildren = expandAllChildren;

var getInitialExpandedReplies = function getInitialExpandedReplies(repliesObject) {
  var expandedReplies = new Set();

  var addReplyIds = function addReplyIds(replies) {
    var result = replies.result,
        metadata = replies.metadata;
    var currentDepthLevel = metadata.depthLevel;
    result.forEach(function (reply) {
      var _children$metadata3;

      var id = reply.id,
          children = reply.children;

      if ((children === null || children === void 0 ? void 0 : (_children$metadata3 = children.metadata) === null || _children$metadata3 === void 0 ? void 0 : _children$metadata3.totalCount) > 0) {
        expandedReplies.add(id);
        addReplyIds(children);
      }
    });
  };

  addReplyIds(repliesObject);
  return expandedReplies;
};

exports.getInitialExpandedReplies = getInitialExpandedReplies;

var collapseAllNestedReplies = function collapseAllNestedReplies(replies, replyId, expandedReplies) {
  var findAndCollapseChildren = function findAndCollapseChildren(repliesData) {
    repliesData.forEach(function (_ref3) {
      var _children$metadata4, _children$metadata5;

      var id = _ref3.id,
          children = _ref3.children;

      if (id === replyId && (children === null || children === void 0 ? void 0 : (_children$metadata4 = children.metadata) === null || _children$metadata4 === void 0 ? void 0 : _children$metadata4.totalCount) > 0) {
        expandedReplies.delete(id);
        collapseAllChildren(children, expandedReplies);
      } else if ((children === null || children === void 0 ? void 0 : (_children$metadata5 = children.metadata) === null || _children$metadata5 === void 0 ? void 0 : _children$metadata5.totalCount) > 0) {
        findAndCollapseChildren(children.result);
      }
    });
  };

  findAndCollapseChildren(replies.result);
};

exports.collapseAllNestedReplies = collapseAllNestedReplies;

var expandAllNestedReplies = function expandAllNestedReplies(replies, replyId, expandedReplies, maxDepth) {
  var findAndExpandChildren = function findAndExpandChildren(repliesData) {
    repliesData.forEach(function (_ref4) {
      var _children$metadata6, _children$metadata7;

      var id = _ref4.id,
          children = _ref4.children;

      if (id === replyId && (children === null || children === void 0 ? void 0 : (_children$metadata6 = children.metadata) === null || _children$metadata6 === void 0 ? void 0 : _children$metadata6.totalCount) > 0) {
        expandedReplies.add(id);
        expandAllChildren(children, expandedReplies, maxDepth);
      } else if ((children === null || children === void 0 ? void 0 : (_children$metadata7 = children.metadata) === null || _children$metadata7 === void 0 ? void 0 : _children$metadata7.totalCount) > 0) {
        findAndExpandChildren(children.result);
      }
    });
  };

  findAndExpandChildren(replies.result);
};

exports.expandAllNestedReplies = expandAllNestedReplies;